import { useSuspenseQuery } from "@apollo/client/react";
import {
  GetEvidenceDetailDocument,
  type GetEvidenceDetailQuery,
  type GetEvidenceDetailQueryVariables,
} from "~/features/evidences/gqls";
import { useTenant } from "~/features/tenant/context";

/** Read a single evidence (Data-tab + lineage fields) for the current tenant. */
export function useEvidenceDetail(id: string) {
  const { tenantId } = useTenant();
  if (!tenantId) throw new Error("Tenant ID is required");
  return useSuspenseQuery<GetEvidenceDetailQuery, GetEvidenceDetailQueryVariables>(GetEvidenceDetailDocument, {
    variables: { tenantId, id },
  });
}
